<mat-accordion class="mat-expansion-refs">
    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" [expanded]="isPanelOpen()" (click)="generateTagIfOpen()" dataqsi="otherReference">
        <mat-expansion-panel-header>
            <div class="title"> {{titleBloc | translate}} </div>
        </mat-expansion-panel-header>
        <div *ngFor="let item of list; let lastItem = last; let firstItem = first;">
            <div class="one_line">
                <div class="picto_container">
                    <img class="picto" src={{item.icon}}>
                </div>
                <div class="content" [ngStyle]="!lastItem ? {'border-bottom': '1px solid #DCDEDC'} : {'padding-bottom': '1vh'}">
                    <div class="alignment">
                        <div class="label_container " [innerHTML]="item.label"></div>
                        <div class="ref_number">N° {{item.value}}</div>
                    </div>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
